import { render, staticRenderFns } from "./AddPanel.vue?vue&type=template&id=6380d484&scoped=true&"
import script from "./AddPanel.vue?vue&type=script&lang=js&"
export * from "./AddPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddPanel.vue?vue&type=style&index=0&id=6380d484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380d484",
  null
  
)

export default component.exports